function AutoSuggest() {

    // -- client id is sent on subsequent requests
    let clientId = null;

    // -- suggestions for the AutoComplete field
    this.getSuggestions = async function (query) {
        const params = {
            q: query,
            mkt: window['app'].getLanguage(false),
        };

        if (clientId) {
            params['client_id'] = clientId;
        }

        const response = await fetch(AUTO_SUGGEST_URL + '?' + new URLSearchParams(params))
            .then((response) => response.json());

        if (typeof response['client_id'] !== 'undefined' && !clientId) {
            clientId = response['client_id'];
        }

        return response;
    }

}